import {
    objectToFormData,
    getJsonWrapper
} from './utils';
import service from '../utils/service';

// 注册
export function userRegistration(params = {}) {
    params = objectToFormData(params);
    return service
        .post('/open/css/module/users/register', params, {
            headers: {
                'content-Type': 'application/x-www-form-urlencoded'
            }
        })
        .then(response => {
            return response;
        });
}

// 修改个人信息
export function updateUserInfo(params) {
    return service.put('/open/css/module/users/instant', getJsonWrapper({}, ['cssUserServiceImpl', [params]]));
}

// 登录login请求
export function postLogin(url, params = {}, publicKey) {
    params = objectToFormData(params);
    return service
        .post(url, params, {
            headers: {
                'SECURITY-RSA-KEY': publicKey,
                'content-Type': 'application/x-www-form-urlencoded'
            }
        })
        .then(response => {
            return response;
        });
}

export function changePwd(userId, params = {}) {
    return service.put(`/secure/core/module/mdm/users/${userId}/action/change-password`, params);
}

// 查询地址列表
export function getAddressList(params) {
    // return service.post(`/secure/css/module/addressbooks/${userId}/select-address`);

    return service.post('/secure/css/module/addressbooks/queries/raw', getJsonWrapper(params));
}

// 修改
export function modifyAddress(params) {
    return service.put(
        '/secure/css/module/addressbooks/instant',
        getJsonWrapper({}, ['cssAddressbookServiceImpl', [params]])
    );
}

// 添加地址列表
export function addAddress(userId) {
    return service.post('/secure/css/module/addressbooks', getJsonWrapper({}, ['', [{
        userId
    }]]));
}

// 删除地址列表
export function delAddress(idArr) {
    return service.delete('/secure/css/module/addressbooks', {
        data: getJsonWrapper({}, ['', idArr])
    });
}

// 设置默认地址
export function setDefaultAddress(id) {
    return service.post('/secure/css/module/addressbooks/action/setdefault', getJsonWrapper({}, ['', [{
        id
    }]]));
}

// 开票信息---------------
export function getBillList(params) {
    // return service.post(`/secure/css/module/user-invoices/${userId}/select-invoice`);
    return service.post('/secure/css/module/user-invoices/queries/raw', getJsonWrapper(params));
}

// 添加
export function addBill(userId) {
    return service.post('/secure/css/module/user-invoices', getJsonWrapper({}, ['', [{
        userId
    }]]));
}

export function modifyBill(params) {
    return service.put(
        '/secure/css/module/user-invoices/instant',
        getJsonWrapper({}, ['cssUserInvoiceServiceImpl', [params]])
    );
}

export function delBill(idArr) {
    return service.delete('/secure/css/module/user-invoices', {
        data: getJsonWrapper({}, ['', idArr])
    });
}

// 设置默认
export function setDefaultBill(id) {
    return service.post(
        '/secure/css/module/user-invoices/action/setdefault-invoice',
        getJsonWrapper({}, ['', [{
            id
        }]])
    );
}

// 开票信息--------------- end

export function getNotifyTypeList() {
    return service.get('/open/css/guideType/select-code');
}

export function getNotificationByType(params) {
    return service.post('/secure/css/module/guides/queries', getJsonWrapper(params));
}

export function getNoticeData(params) {
    return service.post('/open/css/select-notice', getJsonWrapper(params));
}

export function getNotificationDetail(params) {
    return service.post('/secure/css/module/guide-contents/queries', getJsonWrapper(params));
}

export function getReportList(params) {
    return service.post('/secure/css/action/select-report-list', getJsonWrapper(params));
}

// 控制样订购列表
export function getSampleTypeList(params) {
    return service.post('/secure/css/module/control-sample-types/queries/raw', getJsonWrapper(params));
}

export function addSampleOrder(sampleTypeId) {
    return service.post('/secure/css/module/control-sample-orders', getJsonWrapper({}, ['', [{
        sampleTypeId
    }]]));
}

// 修改控制样订单数据
export function updateSampleInfo(params) {
    return service.put('/secure/css/module/control-sample-orders/instant', getJsonWrapper({}, ['cssControlSampleOrderServiceImpl', [params]]));
}

export function getSampleOrderDetail(id) {
    return service.get(`/secure/css/module/control-sample-orders/${id}`);
}

// 控制样订购单参数接口
export function getSampleDynamicIpt(id) {
    return service.get(`/secure/css/module/control-sample-orders/${id}/parameter/fields`);
}

export function updateSampleOrder(params) {
    return service.post('/secure/css/module/control-sample-orders/action/update-order-info', params);
}

// 控制样查询列表
export function getSampleList(params) {
    return service.post('/secure/css/module/control-sample-orders/queries/raw', getJsonWrapper(params));
}

export function generatePDF(idArr) {
    return service.post(
        '/secure/css/module/control-sample-orders/action/create-order-pdf',
        getJsonWrapper({}, ['CssControlSampleOrderServiceImpl', idArr])
    );
}

export function upload(params) {
    params = objectToFormData(params);
    return service
        .post('/core/module/item/files', params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            return response;
        });
}

//删除检测服务列表数据
export function deleteTestServiceTable(id, ids) {
    return service.delete(`/secure/css/module/online-folders/${id}/orders`, {
        data: {
            "p": {
                "type": ""
            },
            "b": ["", ids]
        }
    });
}

//模板下载
export function exportTemplate(id, sampleType, testCategory) {
    return service.get(`/secure/css/module/online-orders/download-cims-template/ExportTemplate?id=${id}&sampleType=${sampleType}&testCategory=${testCategory}`);
}

//首页信息查询
export function queryHomeParams() {
    return service.get(`/open/css/module/configs/home-page-param`);
}

//首页轮播图查询
export function queryHomeImg() {
    return service.get(`/open/css/module/carousel-links/front/carousel`);
}

//查询文件信息
export function queryFile(id) {
    return service.post(`/open/css/select-file/${id}`);
}

//查询单位介绍
export function queryUnitIntroductionList() {
    return service.get(`/open/css/introductionType/select-code`);
}

//查询单位介绍
export function queryUnitIntroduction(params) {
    return service.post(`/open/css/module/unit-introductions/front/queries`, getJsonWrapper(params));
}

//查询单位介绍详情
export function queryUnitIntroductionDetail(id) {
    return service.get(`/open/css/module/unit-introductions/front/${id}`);
}

//上传样品信息
export function uploadSample(id) {
    return service.post(`/core/module/item/files/${id}/action/import/limsOrderImportFileFunction`);
}

//查询中心实验室
export function queryCenterInfo() {
    return service.post(`/open/css/module/orgs/front/queries`);
}

//查询通知公告类型
export function queryType() {
    return service.get(`/open/css/infocategory/select-code`);
}

//查询办事指南列表
export function queryGuideList(params) {
    return service.post(`/open/css/module/guides/front/queries`, getJsonWrapper(params));
}

//查询办事指南详情
export function queryGuideDetail(id) {
    return service.get(`/open/css/module/guides/front/${id}`);
}

//查询下载列表
export function queryDownloadList() {
    return service.get('/open/css/connect-download/queries');
}

//查询文件详情
export function queryFileDetail(id) {
    return service.get(`/core/module/item/files/${id}`);
}

// 查询首页服务菜单
export function queryServiceMenus(menuType) {
    return service.post('/open/css/select-front-menu', getJsonWrapper({
        f: { menuType_SEQ: menuType },
        n: -1,
        o: []
    }));
}
